<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => { if (el) collageItems[index] = el }"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <!-- Modal teletransportado al body para máxima fluidez -->
    <Teleport to="body">
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
          alt="Imagen ampliada"
        />
      </div>
    </Teleport>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',

  setup() {
    const images = [
      require('@/assets/img_2.webp')
    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const collageItems = ref([])
    let observer = null

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    // Animación ultra ligera directa en GPU
    const animateIn = (el) => {
      gsap.fromTo(
        el,
        {
          autoAlpha: 0,
          y: 20
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          ease: 'power1.out',
          force3D: true
        }
      )
    }

    const observeImages = () => {
      const options = {
        threshold: 0.05,
        rootMargin: '0px 0px -20px 0px'
      }

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateIn(entry.target)
            observer.unobserve(entry.target)
          }
        })
      }, options)

      collageItems.value.forEach((el) => {
        if (el) observer.observe(el)
      })
    }

    onMounted(async () => {
      await nextTick()
      const validItems = collageItems.value.filter(Boolean)

      // Estado inicial controlado exclusivamente por JS para evitar pantallas en blanco
      gsap.set(validItems, { autoAlpha: 0, force3D: true })

      if (validItems.length > 0) {
        observeImages()
      }
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: 0 0 50px;
  margin: 0;
  position: relative;
  z-index: 1;
  contain: layout style; /* Aísla cálculos de diseño */
}

.collage-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0;
  line-height: 0;
}

.collage-item {
  grid-column: span 12;
  cursor: pointer;
  overflow: hidden;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.collage-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
}

/* Modal */
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  object-fit: contain;
}
</style>